var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BB6FA81-6001-4AA0-BE8A-76530579562D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1660,
    height: 1010
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1100,
    height: 990
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 1100,
    height: 260
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8288777,8.11857422 L21.718042,0.176835937 C21.6025718,0.0638671875 21.4432639,0 21.2768674,0 L9.18824695,0 C7.83537356,0 6.73470657,1.03675781 6.73470657,2.31105469 L6.73470657,10.3846289 L1.83564716,10.3846289 C0.823463817,10.3846289 0,11.1603516 0,12.1139062 L0,20.7707812 C0,21.7242773 0.823463817,22.5 1.83564716,22.5 L6.73470657,22.5 L6.73470657,27.6929883 C6.73470657,28.9650586 7.83537356,30 9.18824695,30 L27.5464596,30 C28.899333,30 30,28.9656445 30,27.6942773 L30,8.51865234 C30,8.36947266 29.9386273,8.22609375 29.8288777,8.11857422 Z M21.4285892,1.55748047 L28.0868752,8.07691406 L21.4285892,8.07691406 L21.4285892,1.55748047 Z M28.7754683,27.6942773 C28.7754683,28.3294336 28.2241088,28.8461719 27.5463974,28.8461719 L9.18824695,28.8461719 C8.51053554,28.8461719 7.95917606,28.3289063 7.95917606,27.6930469 L7.95917606,22.5 L18.3684725,22.5 C19.3806559,22.5 20.2041197,21.7242773 20.2041197,20.7707813 L20.2041197,12.1139063 C20.2041197,11.1603516 19.3806559,10.3846289 18.3684725,10.3846289 L7.95917606,10.3846289 L7.95917606,2.31105469 C7.95917606,1.67291016 8.51053554,1.15382813 9.18824695,1.15382813 L20.2040575,1.15382813 L20.2040575,8.65382813 C20.2040575,8.97246094 20.4782138,9.23074219 20.8162923,9.23074219 L28.7754683,9.23074219 L28.7754683,27.6942773 Z M2.5,18.7315811 L2.5,14.2684189 L4.21068427,14.2684189 C4.85894682,14.2684189 5.28151162,14.2907447 5.47839136,14.3353968 C5.78091388,14.402375 6.03421267,14.5479997 6.23829532,14.7722752 C6.44237797,14.9965507 6.54441777,15.2862779 6.54441777,15.6414654 C6.54441777,15.9154672 6.48559483,16.1458282 6.36794718,16.3325553 C6.25029953,16.5192824 6.10084124,16.6659219 5.91956783,16.7724782 C5.73829441,16.8790344 5.55402255,16.9495635 5.3667467,16.9840674 C5.11224363,17.0266899 4.74369989,17.0480008 4.26110444,17.0480008 L3.56602641,17.0480008 L3.56602641,18.7315811 L2.5,18.7315811 Z M3.56602641,15.0234423 L3.56602641,16.289933 L4.14945978,16.289933 C4.56962995,16.289933 4.85053951,16.2665925 4.99219688,16.2199107 C5.13385425,16.1732289 5.24489756,16.1001629 5.32533013,16.0007104 C5.40576271,15.9012579 5.44597839,15.78557 5.44597839,15.6536432 C5.44597839,15.4912718 5.38955639,15.3573174 5.27671068,15.2517759 C5.16386498,15.1462345 5.02100927,15.0802721 4.84813926,15.0538867 C4.72088772,15.0335903 4.465188,15.0234423 4.08103241,15.0234423 L3.56602641,15.0234423 Z M7.43037215,18.7315811 L7.43037215,14.2684189 L8.46758703,14.2684189 L10.6284514,17.2489344 L10.6284514,14.2684189 L11.6188475,14.2684189 L11.6188475,18.7315811 L10.5492197,18.7315811 L8.42076831,15.8210879 L8.42076831,18.7315811 L7.43037215,18.7315811 Z M15.2022809,17.0906231 L15.2022809,16.3386442 L17.5,16.3386442 L17.5,18.1166024 C17.2767096,18.2992702 16.9531834,18.460117 16.5294118,18.5991476 C16.1056401,18.7381781 15.6764728,18.8076923 15.2418968,18.8076923 C14.6896731,18.8076923 14.2082854,18.7097635 13.7977191,18.513903 C13.3871528,18.3180425 13.0786325,18.037956 12.8721489,17.6736351 C12.6656652,17.3093142 12.562425,16.9130324 12.562425,16.4847778 C12.562425,16.0199896 12.6776699,15.6069634 12.9081633,15.245687 C13.1386566,14.8844106 13.4759882,14.6073685 13.9201681,14.4145525 C14.2587052,14.2663885 14.6800695,14.1923077 15.1842737,14.1923077 C15.8397392,14.1923077 16.3517389,14.308503 16.7202881,14.5408971 C17.0888374,14.7732912 17.3259298,15.0944773 17.4315726,15.5044652 L16.3727491,15.6719099 C16.298319,15.4527085 16.1584644,15.279684 15.9531813,15.1528313 C15.7478981,15.0259787 15.4915982,14.9625533 15.1842737,14.9625533 C14.7184851,14.9625533 14.3481406,15.0873744 14.0732293,15.3370205 C13.798318,15.5866666 13.6608643,15.9570708 13.6608643,16.4482444 C13.6608643,16.9779811 13.8001187,17.3752778 14.0786315,17.6401461 C14.3571442,17.9050145 14.7220866,18.0374467 15.1734694,18.0374467 C15.3967598,18.0374467 15.6206471,18.0004063 15.8451381,17.9263243 C16.069629,17.8522424 16.2623041,17.762432 16.4231693,17.6568906 L16.4231693,17.0906231 L15.2022809,17.0906231 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-3.1_Retailer_Profile_01",
    transform: "translate(-810.000000, -1435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1660
  })), /*#__PURE__*/React.createElement("g", {
    id: "Conteainer",
    transform: "translate(220.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  }), /*#__PURE__*/React.createElement("g", {
    id: "Backgorund",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Block_Left",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 650.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Bound",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 520,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf",
    transform: "translate(10.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_file_png"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-8)",
    fill: "#2CCB8D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.d3896804dc3e90948bbbd2bd14d7d7a4.svg";
export { ForwardRef as ReactComponent };